import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, Output, EventEmitter, Input, ElementRef, HostListener } from '@angular/core';
import SignaturePad from 'signature_pad';
import { trigger, style, animate, transition, state } from '@angular/animations';
import { Observable, Subject } from 'rxjs';
import { UtilitiesService } from '../../../../../services/utilities.service';
import { LocalApiConnectorService } from '../../../../../services/local-api-connector.service';
import { DomSanitizer } from '@angular/platform-browser';
import { LocationService } from '../../../../../services/location.service';
import { DocumentService } from '../../../../../services/document.service';
import { NgxUiLoaderService } from 'ngx-ui-loader'
import { ConfigService } from '../../../../../services/endpoint.config.service';
import { ReceiptService } from '../../../../../services/receipt.service';
import { TranslateService } from '@ngx-translate/core';
import { InvalidMobileErrorService } from 'src/app/services/invlid-mobile-error.service';
import { SETTING_KEY_FOR_EMAIL_OPTIONAL, SETTING_KEY_FOR_PHONE_NUMBER_OPTIONAL } from 'src/app/shared/constants';
import { ToastrService } from 'ngx-toastr';

declare let $: any;

declare function IsSigWebInstalled(): boolean;
declare function GetSigWebVersion(): string;
declare function isSigWeb_1_7_0_0_Installed(sigWebVer: any): boolean;
declare function isSigWeb_1_6_4_0_Installed(sigWebVer: any): boolean;
declare function SetDisplayXSize(v: number): string;
declare function SetDisplayYSize(v: number): string;
declare function SetTabletState(v: number, ctx: CanvasRenderingContext2D, tv: number): any;
declare function SetJustifyMode(v: number): string;
declare function ClearTablet(): string;
declare function NumberOfTabletPoints(): string;
declare function SetSigCompressionMode(v: number): string;
declare function GetSigString(): string;
declare function SetImageXSize(v: number): string;
declare function SetImageYSize(v: number): string;
declare function SetImagePenWidth(v: number): string;
declare function GetSigImageB64(callback: any): string;


@Component({
  selector: 'receipt-scanner',
  templateUrl: './receipt-scanner.component.html',
  styleUrls: ['./receipt-scanner.component.scss'],
  animations: [
    trigger('openClose', [
      state('open', style({
        opacity: 1,
        display: 'block'
      })),
      state('closed', style({

        opacity: 0,
        display: 'none'

      })),
      transition('open => closed', [
        animate('0.5s')
      ]),
      transition('closed => open', [
        animate('0.5s')
      ]),
    ]),
  ]
})

export class ReceiptScannerComponent implements OnInit, OnDestroy {

  @Output() scannerObject = new EventEmitter();
  @Output() consigneeObject = new EventEmitter();
  signPad: any;
  @ViewChild('signPadCanvas', { static: false }) signaturePadElement: any;
  @ViewChild('cnv', { static: false }) canvasRef: ElementRef<HTMLCanvasElement>;
  private tmr: any = null;
  signImage: any;
  scannedImage1 = this._sanitizer.bypassSecurityTrustResourceUrl("");
  scannedImage2 = this._sanitizer.bypassSecurityTrustResourceUrl("");
  public signaturePadOptions: Object = { // passed through to szimek/signature_pad constructor
    'minWidth': 5,
    'canvasWidth': 750,
    'canvasHeight': 120,

  };
  phoneNumber: any = null;
  consigneeName: any = null;
  emailAddress: any = null;
  isScaningLocked: boolean = true;
  isScaningCiLocked: boolean = true
  scanText = `${this.translate.instant('common.scan')}`;
  scanText2 = 'Scan';
  sss: any;
  result: string = "";
  isScanStarted: boolean = false;
  isScanProceed: boolean = false;
  disableNext: boolean = true;
  isPhoneNumberOptional = true;
  isEmailOptional = true;
  anyLocalShipmentFound = false;
  ScannedFile = [];
  PodCustomerIdNumber: string = "";
  isNormalUploadDone = false;
  extraAWBs: string[] = [];
  missingAWBs: string[] = [];
  @Input() shipments;

  @Input() hasInboundShipment;
  @Input() hasOutboundShipment;
  @Input() hasMiscShipment;
  @Input() hasDropOffShipment;
  @Input() OutboundIDScanRequired;
  @Input() PODIDScanRequired;
  @Input() PODSignatureRequired;
  @Input() scanners;
  @Input() hasPackagingShipment;
  @Input() shippments;

  receipt = {} as receipt as any;
  IsTopazIntegrated = false;
  resetIsSupported = false;
  SigWeb_1_6_4_0_IsInstalled = false;
  SigWeb_1_7_0_0_IsInstalled = false;
  isInstalled = false;
  sigWebLink = "https://www.topazsystems.com/software/sigweb.exe";
  topazSigbase64 = "";
  scanBuffer: string = '';
  scannedAWBs: string[] = []; // Example scanned AWBs
  lastScannedAWB: string = '';
  inboundNumbers: string[] = [];
  locationSettings: any[] = JSON.parse(sessionStorage.getItem('branchSettings'));
  scannedValue: string;
  mismatchedNumbers: string[] = [];
  isTwoWayInboundAuthEnabled: boolean = false;


  private scanTimeout: any;
  private lastKeyTime = 0;
  private scanThreshold = 50;
  private clearDelay = 100;
  scannerInput
  scanTimer: any;


  toArray(obj) {
    var arr = [];
    for (var x in obj) if (obj.hasOwnProperty(x)) {
      arr.push(obj[x]);
    }
    return arr;
  }

  networkId: number

  constructor(private utilities: UtilitiesService,
    private locationService: LocationService,
    private receiptService: ReceiptService,
    private DocumentService: DocumentService,
    private agent: LocalApiConnectorService,
    private _sanitizer: DomSanitizer,
    private configs: ConfigService,
    private loader: NgxUiLoaderService,
    private translate: TranslateService,
    private mobileErrorService: InvalidMobileErrorService,
    private toaster: ToastrService
  ) {
    var BranchSetting = JSON.parse(sessionStorage.getItem("branchSettings"));
    this.IsTopazIntegrated = BranchSetting.filter((x) => x.Key == 38)[0] != undefined ? (BranchSetting.filter((x) => x.Key == 38)[0].Value == "True") : false;

    var user = JSON.parse(sessionStorage.getItem("user"));
    this.networkId = user.Network.NetworkId;

  }

  ngOnInit() {

    var settings = JSON.parse(sessionStorage.getItem('branchSettings'));
    this.isTwoWayInboundAuthEnabled = settings.filter(x => x.Key == 43)[0] != undefined ? (settings.filter(x => x.Key == 43)[0].Value) == 'True' : false;
    console.log('Is Two Way Inbound Auth Enabled:', this.isTwoWayInboundAuthEnabled);

    this.inboundNumbers = this.shipments.inbound.map(x => x.Shipment.Number);


    if (Array.isArray(this.shipments.inbound) && this.shipments.inbound.length > 0)
      this.anyLocalShipmentFound = this.shipments.inbound.some((item) => item.Shipment?.IsLocalized == true);

    if (this.anyLocalShipmentFound === true) {
      this.isPhoneNumberOptional = true;
    } else {
      const phoneOptionalSetting = this.locationSettings.find(m => m.Key == SETTING_KEY_FOR_PHONE_NUMBER_OPTIONAL);
      this.isPhoneNumberOptional = phoneOptionalSetting != undefined ? phoneOptionalSetting.Value == 'True' : false;
    }

    const emailOptionalSetting = this.locationSettings.find(m => m.Key == SETTING_KEY_FOR_EMAIL_OPTIONAL);
    this.isEmailOptional = emailOptionalSetting != undefined ? emailOptionalSetting.Value == 'True' : false;

    this.validatorObject.Mobile.valid = this.isPhoneNumberOptional ? true : false;
    this.validatorObject.Email.valid = this.isEmailOptional ? true : false;

    if (this.hasOutboundShipment || this.hasDropOffShipment || this.hasPackagingShipment)
      this.validateNext()

    this.isNormalUploadDone = false;
    this.sss = $("#dvamxscan").amxScanMngr('992ada1b68b34b618173a221393ba8ce', this.configs.getEnviromentId());
    this.sss.start();
    this.sss.result = function (e) {
      console.log('[SSS] Connection result:', e);
      var y = e;
    };

    if (this.hasMiscShipment && !this.hasInboundShipment && !this.hasOutboundShipment) {
      this.next();
    }

    if (!this.isMobile()) {
      //WebcamUtil.getAvailableVideoInputs()
      //  .then((mediaDevices: MediaDeviceInfo[]) => {
      //    this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
      //  });
    }


console.log('before Topaz Integrated')
console.log('check if topaz integrated',this.IsTopazIntegrated)
    if (this.IsTopazIntegrated) {
      console.log('Topaz Integrated')
      //this method check if the needed software is installed, but it doesnt check if the hardware is connected <3
      if (IsSigWebInstalled()) {
        this.isInstalled = true;
        var sigWebVer = '';
        try {
          sigWebVer = GetSigWebVersion();
          console.log('Signature Web Version is = ' + sigWebVer);
        } catch (err) {
          console.log('Unable to get SigWeb Version: ' + err);
        }

        if (sigWebVer != '') {
          try {
            this.SigWeb_1_7_0_0_IsInstalled =
              isSigWeb_1_7_0_0_Installed(sigWebVer);
          } catch (err) {
            console.log(err);
          }
          if (this.SigWeb_1_7_0_0_IsInstalled) {
            this.resetIsSupported = true;
          } else {
            try {
              this.SigWeb_1_6_4_0_IsInstalled =
                isSigWeb_1_6_4_0_Installed(sigWebVer);
              //if SigWeb 1.6.4.0 is installed, then enable corresponding functionality
            } catch (err) {
              console.log(err);
            }
            if (this.SigWeb_1_6_4_0_IsInstalled) {
              this.resetIsSupported = true;
              var sigweb_link = document.createElement('a');
              sigweb_link.href =
                'https://www.topazsystems.com/software/sigweb.exe';
              sigweb_link.innerHTML =
                'https://www.topazsystems.com/software/sigweb.exe';
            } else {
              var sigweb_link = document.createElement('a');
              sigweb_link.href =
                'https://www.topazsystems.com/software/sigweb.exe';
              sigweb_link.innerHTML =
                'https://www.topazsystems.com/software/sigweb.exe';
            }
          }
        } else {
          //Older version of SigWeb installed that does not support retrieving the version of SigWeb (Version 1.6.0.2 and older)
          var sigweb_link = document.createElement('a');
          sigweb_link.href = 'https://www.topazsystems.com/software/sigweb.exe';
          sigweb_link.innerHTML =
            'https://www.topazsystems.com/software/sigweb.exe';
        }
      } else {
        alert(
          'Unable to communicate with SigWeb. Please confirm that SigWeb is installed and running on this PC.'
        );
      }
    }

  }


  scanIdObj: any = "";
  scanningTimer: any = null;
  ScanIdScannerName = "-1";

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    const currentTime = new Date().getTime();
    const timeDiff = currentTime - this.lastKeyTime;

    // If time since last key is more than threshold, treat this as new input (likely a new scan)
    if (timeDiff > this.scanThreshold) {
      this.scanBuffer = '';  // clear previous buffer
    }

    this.lastKeyTime = currentTime;
    const numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

    if (event.key === 'Enter') {
      console.log('Scanned Value:', this.scanBuffer);
      this.scannedAWBs.push(this.scanBuffer);
      this.lastScannedAWB = this.scanBuffer;
      this.scanBuffer = '';
    } else if (numbers.includes(event.key)) {
      this.scanBuffer += event.key;
    }

    // Optionally, clear buffer after a short delay in case no Enter comes
    clearTimeout(this.scanTimeout);
    this.scanTimeout = setTimeout(() => {
      this.scanBuffer = '';
    }, this.clearDelay);
  }

  getScanIdImage() {
    var imagePath = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + this.scanIdObj.Result);
    return imagePath;
  }
  getScanCiImage() {
    var imagePath = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + this.scanCiObj.Result);
    return imagePath;
  }

  scannerName = -1;
  hideLoader = true;

  scanId() {
    var _this = this;

    console.log('[SSS] Triggering scan, sss instance:', _this.sss);

    _this.sss.scan({
      'documentId': 1
    });

    _this.sss.onAfterScan = function (data) {
      console.log('[SSS] onAfterScan data:', data);

      _this.saveScannedImage(data, _this);
    }
  }

  saveScannedImage(data, _this) {

    console.log(data);
    _this.ScannedFile = _this.ContentOfFile(data);

    var SourceID = 1;
    var file = _this.ScannedFile;
    var FileName = "CustomerID.png";//add to all AWB's

    //get the AWB number to create the request
    //Inbound ************************
    if (_this.shipments.inbound.length > 0) {
      _this.shipments.inbound.forEach((item) => {
        var AWBNumber = item.Shipment.Number;

        _this.DocumentService.AddDocumentByAWB(SourceID, AWBNumber, FileName, file, (res) => {
          console.log("res", res);
          var temp: any = [];
          temp = res;
          if (temp.isSuccessful) {
            item.hasCustomerID = true;
          }
        }, (err) => {
          this.toaster.error("Failed to add document by AWB")
        })
      })
    }
    //Outbound ****************************
    if (_this.shipments.outbound.length > 0) {
      _this.shipments.outbound.forEach((item) => {
        var AWBNumber = item.Shipment.Number;
        //Add CustomerID file 
        _this.DocumentService.AddDocumentByAWB(SourceID, AWBNumber, FileName, file, (res) => {
          console.log("AddDocumentByAWB CustomerID file", res);
          var temp: any = [];
          temp = res;
          if (temp.isSuccessful) {
            item.hasCustomerID = true;
          }
        }, (err) => {
          this.toaster.error("Failed to add document by AWB")
        })
        //Add Commercial Invoice file if it exists
        if (item.commercialInvoice != null) {
          _this.isNormalUploadDone = true;
          _this.uploadOutboundToAWB(AWBNumber, SourceID, item.commercialInvoice);

          /*
          var InvoiceFileName = AWBNumber.concat("_Invoice.png");
          _this.DocumentService.AddDocumentByAWB(SourceID, AWBNumber, InvoiceFileName, item.commercialInvoice, (res) => {
            console.log("res", res);
          }, (err) => {

          })
          */
        }
      })
    }
  }

  uploadOutboundToAWB(AWBNumber, sourceID, commercialInvoice, isFromPayment = false) {
    //Add Commercial Invoice file if it exists
    if (commercialInvoice != null) {
      var InvoiceFileName = AWBNumber.concat("_Invoice.png");

      this.DocumentService.AddDocumentByAWB(sourceID, AWBNumber, InvoiceFileName, commercialInvoice, (res) => { }, (err) => { this.toaster.error("Failed to add document by AWB") })
    }
  }

  scanCiObj: any = "";
  scannerName2 = -1;
  scanCi() {
    if (this.scannerName2 == -1) {
      return false;
    }
    this.scanCiObj = "";
    if (this.isMobile()) {
      if (this.isScaningCiLocked) {
        this.isScaningCiLocked = false;
        this.scanText2 = 'Start scanning';
      }
      else {
        this.isScaningCiLocked = true;
        //this.triggerSnapshot();
      }
    }
    else {
      this.hideLoader = false;
      var param = { "ScannerName": this.scannerName2 };
      this.agent.startScaning((res) => {
        this.scanText = `${this.translate.instant('common.scanning')}`;
        this.scanningTimer = setInterval(() => {
          this.agent.getScanningResult((res) => {
            if (this.scanCiObj == "") {
              this.scanCiObj = res;
              this.scannedImage2 = this.getScanCiImage()
              this.hideLoader = true;
            }
            else {
              this.scanText = `${this.translate.instant('common.scan')}`;
              clearInterval(this.scanningTimer);
            }
          })
        }, 1000)

      }, param);
    }
    setTimeout(x => {
      this.hideLoader = true;
      this.scanText = `${this.translate.instant('common.scan')}`;
      this.scannedImage2 = this.getScanCiImage()
    }, 10000);
  }


  data = {
    signature: "",
    id: "",
    ci: ""
  };

  ngAfterViewInit() {
    if (this.hasInboundShipment && !this.IsTopazIntegrated) {
      this.signPad = new SignaturePad(this.signaturePadElement.nativeElement, {
        backgroundColor: '#ffffff',
      });
    }
  }


  startSignPadDrawing(event: Event) {
    console.log(event);
  }

  movedFinger(event: Event) {
  }

  clearSignPad() {
    this.signPad.clear();
    this.data.signature = "";
    this.signImage = "";
    this.validateNext();
  }

  /*Here you can save the signature as a Image*/
  saveSignPad() {
    this.data.signature = this.signPad.toDataURL()
    this.signImage = this.data.signature;
    this.validateNext();
  }

  isMobile() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      return true;
    }
    else {
      return false;
    }
  }

  b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    //return blob;
    return byteArrays;
  }

  imagetoblob(imageUrl) {
    var ImageURL = imageUrl
    var block = ImageURL.split(";");
    var contentType = block[0].split(":")[1];
    var realData = block[1].split(",")[1];
    return this.b64toBlob(realData, contentType, 512);
  }

  ContentOfFile(base64) {
    var Base64 = base64
    var block = Base64.split(";");
    var contentType = block[0].split(":")[1];
    var realData = block[1].split(",")[1];
    return realData;
  }


  onSign() {
    console.log("inside the signin")
    if (IsSigWebInstalled()) {
      this.topazSigbase64 = "";
      const canvas = this.canvasRef.nativeElement;
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        console.error('Failed to get canvas context');
        return;
      }

      SetDisplayXSize(500);
      SetDisplayYSize(100);
      this.stopTopazCapture();
      SetJustifyMode(0);
      ClearTablet();

      this.tmr = SetTabletState(1, ctx, 50);
    } else {
      alert('Unable to communicate with SigWeb. Please confirm that SigWeb is installed and running on this PC.');
    }
  }

  onClear() {
    ClearTablet();
    this.data.signature = "";
    this.topazSigbase64 = "";
    this.signImage = "";
    this.validateNext();
  }

  onDone() {
    this.topazSigbase64 = "";
    if (NumberOfTabletPoints() == '0') {
      alert("Please sign before continuing");
    } else {
      this.stopTopazCapture();
      SetSigCompressionMode(1);

      SetImageXSize(500);
      SetImageYSize(100);
      SetImagePenWidth(5);
      GetSigImageB64(this.SigImageCallback.bind(this));
    }
    this.validateNext();
  }

  SigImageCallback(str: string) {
    this.topazSigbase64 = str;
    if (this.IsTopazIntegrated) {
      let temp = "data:image/png;base64,";
      this.data.signature = temp.concat(this.topazSigbase64);
      this.signImage = this.data.signature;
      this.validateNext();
    }
  }

  ngOnDestroy(): void {
    if (this.tmr !== null) {
      this.stopTopazCapture();
    }
  }

  private stopTopazCapture(): void {
    const activeTimer = this.tmr;

    if (activeTimer !== null) {
      window.clearInterval(activeTimer);
      this.tmr = null;
    }

    SetTabletState(0, activeTimer, 0);
  }

  //********************************************************** */

  webcamCapturedImage: string | null = null;
  showWebcamModal: boolean = false;
  handleWebcamCapturedImage(base64Image) {
    this.webcamCapturedImage = base64Image;
    this.saveScannedImage(base64Image, this)
  }

  validatorObject = {
    Mobile: {
      valid: false,
      message: ''
    },
    ConsigneeId: {
      valid: false,
      message: ''
    }
    ,
    Name: {
      valid: false,
      message: ''
    }
    ,
    Email: {
      valid: false,
      message: ''
    },
    PodCustomerIdNumber: {
      valid: true,
      message: ''
    }
  }

  checkPodCustomerIdNumber() {
    if (this.PodCustomerIdNumber.length > 0) {
      var isAlphanumricNum = /^[a-z0-9/\s/g]+$/i.test(this.PodCustomerIdNumber);
      if (!isAlphanumricNum) {
        this.validatorObject.PodCustomerIdNumber.valid = false;
        this.validatorObject.PodCustomerIdNumber.message = `${this.translate.instant('pages.createReceiptPage.oneReceipt.scanner.alphanumricDigitAllow')}`;
        this.disableNext = true;
      }
      else if (this.PodCustomerIdNumber.length >= 50) {
        this.validatorObject.PodCustomerIdNumber.valid = false;
        this.validatorObject.PodCustomerIdNumber.message = `${this.translate.instant('pages.createReceiptPage.oneReceipt.scanner.textLengthValidation')}`;
        this.disableNext = true;

      }
      else {
        this.validatorObject.PodCustomerIdNumber.valid = true;
        this.validatorObject.PodCustomerIdNumber.message = "";
        this.consigneeObject.emit({ 'consigneeName': this.consigneeName, 'emailAddress': this.emailAddress, 'phoneNumber': this.phoneNumber, 'customerPodIdNumber': this.PodCustomerIdNumber });
        this.disableNext = false;
      }
    }

  }

  getNameCount() {
    if (this.consigneeName != null && typeof this.consigneeName == 'string') {
      return this.consigneeName.length;
    }

    return 0;
  }

  checkName() {
    if (this.consigneeName !== null && this.consigneeName !== "") {
      this.validatorObject.Name = {
        valid: true,
        message: ''
      }
      this.consigneeObject.emit({ 'consigneeName': this.consigneeName, 'emailAddress': this.emailAddress, 'phoneNumber': this.phoneNumber, 'customerPodIdNumber': this.PodCustomerIdNumber });
      return true;
    }
    else {
      this.validatorObject.Name = {
        valid: false,
        message: '<i class="armx-icon armx-cancel"></i> ' + `${this.translate.instant('pages.createReceiptPage.oneReceipt.scanner.requiredField')}`,
      }
      return false;
    }
  }

  checkEmail() {
    if (this.isEmailOptional && this.isEmptyOrNull(this.emailAddress)) {
      return;
    }
    var validEmail = this.validateEmail(this.emailAddress);
    if (validEmail) {
      this.validatorObject.Email = {
        valid: true,
        message: ''
      }
      this.consigneeObject.emit({ 'consigneeName': this.consigneeName, 'emailAddress': this.emailAddress, 'phoneNumber': this.phoneNumber, 'customerPodIdNumber': this.PodCustomerIdNumber });
      return true;
    }
    else {
      this.validatorObject.Email = {
        valid: false,
        message: '<i class="armx-icon armx-cancel"></i> ' + `${this.translate.instant('pages.createReceiptPage.oneReceipt.scanner.validEmailText')}`,
      }
      return false;
    }
  }

  validateNext() {

    this.data.id = this.scanIdObj.Result != null ? this.scanIdObj.Result : null;
    this.data.ci = this.scanCiObj.Result != null ? this.scanIdObj.Result : null;

    if (this.hasInboundShipment) {
      if (this.validatorObject.Mobile.valid && this.checkName()) {
        if (this.PODIDScanRequired == "True" && this.PODSignatureRequired == "True") {
          if (this.data.id !== "" && this.data.signature !== "" && this.data.id !== null && this.data.signature !== null)
            this.disableNext = false;
          else
            this.disableNext = true;
        }
        else if (this.PODIDScanRequired == "True" && this.PODSignatureRequired != "True") {
          if (this.data.id !== "" && this.data.id !== null)
            this.disableNext = false;
          else
            this.disableNext = true;
        }
        else if (this.PODIDScanRequired != "True" && this.PODSignatureRequired == "True") {
          if (this.data.signature !== "" && this.data.signature !== null)
            this.disableNext = false;
          else
            this.disableNext = true;
        }
        else if (this.PODIDScanRequired != "True" && this.PODSignatureRequired != "True") {
          this.disableNext = false;
        }
      }

      else {
        this.disableNext = true;
      }
    }
    else if (this.hasOutboundShipment) {
      if (this.OutboundIDScanRequired == "True") {
        if (this.data.id != "" && this.data.id !== null)
          this.disableNext = false;
        else
          this.disableNext = true;
      }
      else {
        this.disableNext = false;
      }
    } else if (this.hasDropOffShipment) {
      this.disableNext = false;
    } else if (this.hasPackagingShipment) {
      console.log('this disableNext', this.disableNext);
      this.disableNext = false;
    }
  }

  isEmptyOrNull(data: any) {
    return data == null || (typeof data === "string" && data.trim().length === 0);
  }

  resolvePhoneNumber() {
    if (this.isPhoneNumberOptional && this.isEmptyOrNull(this.phoneNumber)) {
      return;
    }
    var countryCode = JSON.parse(sessionStorage.getItem("company")).BranchCompanyCountryCode;
    this.utilities.resolvePhone({
      CountryCode: countryCode,
      PhoneNumber: this.phoneNumber
    },
      (res) => {
        this.phoneNumber = res.PhoneNumber;
        this.validatorObject.Mobile = {
          valid: true,
          message: ''
        }


        this.validateNext();
      }, (err) => {
        this.validatorObject.Mobile = {
          valid: false,
          message: '<i class="armx-icon armx-cancel"></i> ' + this.mobileErrorService.getErrorMessage(err),
        }
        this.validateNext();
      });
  }

  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  next() {
    if (!this.hasMiscShipment) {
      this.data.id = this.scanIdObj.Result != null ? this.scanIdObj.Result : null;
      this.data.ci = this.scanCiObj.Result != null ? this.scanIdObj.Result : null;
      this.validateNext();
      this.validatorObject.ConsigneeId = {
        valid: true,
        message: ''
      }
      if (this.isTwoWayInboundAuthEnabled && this.hasInboundShipment) {
        this.TwoWayInboundAuthEnabled()
      } else {
        if (this.disableNext == false) {
          if (this.isNormalUploadDone == false && this.shipments.outbound.length > 0) {
            var SourceID = 1;

            this.shipments.outbound.forEach((item) => {
              this.uploadOutboundToAWB(item.Shipment.Number, SourceID, item.commercialInvoice, true);
            });
          }

          this.scannerObject.emit(this.data);
        }
      }




    }
    else {
      this.scannerObject.emit(null);
    }
  }




  @Output() previousTrigger = new EventEmitter();
  previous() {
    this.previousTrigger.emit(true);
  }

  clearScannedAWBs() {
    this.scannedAWBs = [];
    this.missingAWBs = [];
    this.extraAWBs = [];
  }

  TwoWayInboundAuthEnabled() {
    if (this.isTwoWayInboundAuthEnabled) {
      this.extraAWBs = this.scannedAWBs.filter(awb => !this.inboundNumbers.includes(awb));

      this.missingAWBs = this.inboundNumbers.filter(awb => !this.scannedAWBs.includes(awb));

      if (this.extraAWBs.length > 0 || this.missingAWBs.length > 0) {
        console.log('Extra AWBs (Unexpected):', this.extraAWBs);
        console.log('Missing AWBs (Not scanned):', this.missingAWBs);
        return;
      }
      if (this.disableNext == false) {
        if (this.isNormalUploadDone == false && this.shipments.outbound.length > 0) {
          var SourceID = 1;
          this.shipments.outbound.forEach((item) => {
            this.uploadOutboundToAWB(item.Shipment.Number, SourceID, item.commercialInvoice, true);
          });
        }

        this.scannerObject.emit(this.data);
      }

    }


  }


}






